module.exports = __webpack_public_path__ + "static/media/animate_arrow.8b6332a8.svg";